import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import fillWithPlaceholders from 'utils/components/fillWithPlaceholders';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import Tooltip from 'components/Tooltip';
import {Request, RequestsMixin, GET, DELETE} from 'requests';
import ResourcesMatching from 'requests/components/ResourcesMatching';
import Requesting from 'requests/components/Requesting';
import Done from 'requests/components/Done';
import ImageSummaryCard from './ImageSummaryCard';
import ImageCardPlaceholder from './ImageCardPlaceholder';

const NUMBER_OF_IMAGES_NEEDED = 8;
const IMAGE_MULTIPLES = 4;

const mapStateToProps = (state, props) => {
  const kitToken = props.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const ImagesSummary = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    requests: PropTypes.object.isRequired,
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      usingFocused: false,
      showUsageBetaTooltip: false,
    };
  },

  componentWillMount() {
    this.setRequest({
      workingSetImages: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-images'],
      }),
    });
  },

  handleUsingFocused() {
    this.setState({usingFocused: !this.state.usingFocused});
  },

  toggleShowUsageBetaTooltip() {
    this.setState({showUsageBetaTooltip: !this.state.showUsageBetaTooltip});
  },

  resources() {
    const rm = this.resourceManager();

    return {
      workingSetImages: rm.type(this.requests.workingSetImages, 'working-set-images').all(),
    };
  },

  renderImages() {
    const {
      kitToken,
    } = this.props;
    const {
      workingSetImages: workingSetImagesRequest,
    } = this.requests;
    const rm = this.resourceManager();
    const workingSetImages = rm.type(workingSetImagesRequest, 'working-set-images').all();
    const sortedWorkingSetImages = workingSetImages
      .filter(record => record.status === "finished")
      .sortBy(record => record.createdAt.unix()).reverse();

    const cardElements = sortedWorkingSetImages
      .take(NUMBER_OF_IMAGES_NEEDED)
      .map((workingSetImage, index) => {
        return (
          <ImageSummaryCard
            key={workingSetImage.id}
            kitToken={kitToken}
            workingSetImage={workingSetImage}
          />
        );
      });

    const elements = fillWithPlaceholders(cardElements, {
      placeholder: ImageCardPlaceholder,
      multipleOf: IMAGE_MULTIPLES,
      minimum: NUMBER_OF_IMAGES_NEEDED,
      props: {kitToken},
    });

    return (
      <div className="grid-assets grid-assets-xs-4 kit-assets kit-assets-images-sm">
        {elements}
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-images-summary m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  renderUsage() {
    const {
      workingSetImages,
    } = this.resources();
    const {showUsageBetaTooltip} = this.state;

    const imagesUsed = workingSetImages.size;
    const usageBetaTooltip = (this.state.showUsageBetaTooltip) ?
      <Tooltip noIcon={true} content={"Use as many images as you'd like<br /> while this feature is in beta"} /> :
      null;

    return (
      <div onMouseEnter={this.toggleShowUsageBetaTooltip} onMouseLeave={this.toggleShowUsageBetaTooltip} className="text-muted m-xs-b-md">
        <span className="has-tooltip">
          {usageBetaTooltip}
          Using {imagesUsed} of &infin; available
        </span>
      </div>
    );
  },

  render() {
    const {
      kitToken,
    } = this.props;
    const rm = this.resourceManager();

    return (
      <ResourcesMatching manager={rm}>
        <div className="kit-asset-summary">
          <div className="kit-asset-header">
            <h3 className="kit-asset-title">
              <Link to={`/kits/${kitToken}/images`} className="link-dashed-none">Images</Link>
            </h3>
            <div className="kit-asset-actions">
              <Link to={`/kits/${kitToken}/images/upload`} className="link-dashed-none">
                <i className="ficon ficon-uploaded m-xs-r-xs"></i>Upload
              </Link>
            </div>
          </div>
          <hr className="m-xs-y-sm" />
          <div className="kit-asset-preview">
            <Requesting any={true} render={this.renderSpinner} />
            <Done all={true} render={this.renderImages} />
          </div>
          <hr className="m-xs-b-sm m-xs-t-0" />
          <div className="kit-footer">
            {this.renderUsage()}
          </div>
        </div>
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(ImagesSummary);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/ImagesSummary.js